import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '@/lib/db/database'

export function useNavCounts() {
  const bookingRequestCount = useLiveQuery(
    () =>
      db.bookings
        .filter((b) => b.status === 'request')
        .count(),
    [],
    0,
  )

  const collectionRequestCount = useLiveQuery(
    () =>
      db.customerOrders
        .filter((o) => o.status === 'request')
        .count(),
    [],
    0,
  )

  const posActiveCount = useLiveQuery(
    () =>
      db.posOrders
        .filter((o) => o.status === 'open' || o.status === 'sent')
        .count(),
    [],
    0,
  )

  return {
    bookings: bookingRequestCount ?? 0,
    collections: collectionRequestCount ?? 0,
    pos: posActiveCount ?? 0,
  }
}
